import { ControllerRenderProps } from 'react-hook-form'
import { isEmpty, isNil } from 'lodash-es'
import { useCallback } from 'react'

import { CategoryWithChildren } from 'features/categories/interfaces'
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from 'shadcdn/ui/select'

export function CategorySelectField(props: {
  field: ControllerRenderProps<any, any> // Can't get with types here... So any only
  categories: CategoryWithChildren[]
  className: string
}) {
  const value = !isNil(props.field.value) ? String(props.field.value) : undefined
  const onChange = props.field.onChange
  const handleValueChange = useCallback(
    (newValue: string) => {
      onChange(parseInt(newValue))
    },
    [onChange]
  )
  return (
    <Select value={value} onValueChange={handleValueChange}>
      <SelectTrigger className="py-3">
        <SelectValue placeholder="Select category" />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {props.categories.map((cat) => (
            <CategoryItem category={cat} key={cat.id} />
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  )
}

const CategoryItem = ({ category, offset = 2 }: { category: CategoryWithChildren; offset?: 2 | 4 | 6 }) => {
  const padding = {
    2: 'pl-6',
    4: 'pl-8',
    6: 'pl-10 ',
  }[offset]

  if (!category.children || isEmpty(category.children)) {
    return (
      <SelectItem className={padding} value={String(category.id)}>
        {category.name}
      </SelectItem>
    )
  }

  return (
    <div>
      <SelectLabel className={padding}>{category.name}</SelectLabel>
      {category.children.map((subcategory) => (
        <CategoryItem category={subcategory} offset={(offset + 2) as any} key={subcategory.id} />
      ))}
    </div>
  )
}
